import React from 'react'
import { Link } from 'react-router'

function RerunUrlDisplay(record) {
  return <Link title="Re-run" to={`/smoke_checks/${record.id}`}>Re-run</Link>
}

export default RerunUrlDisplay
